<template>
  <van-sticky>
    <div class="header-wrap">
      <img :src="require('@/assets/img/logo.png')" />
      <div v-if="$route.path !== '/foreignPage'" class="tabs-warp">
        <div class="title" @click="toHomePage">首页</div>
        <div class="title" @click="showBrandMatrix = true">品牌专栏</div>
       
        <van-dropdown-menu>
          <van-dropdown-item ref="assignPlatRef" title="赋能平台">
            <ul class="company-wrap">
              <li
                v-for="item in assignPlats"
                :key="item"
                @click="toAssignPlat(item)"
              >
                {{ item.enableCompanyName }}
              </li>
            </ul>
          </van-dropdown-item>
        </van-dropdown-menu>
        <div class="title" @click="toAssignPlat({ id: 1 })">会员体系</div>
         <van-dropdown-menu>
          <van-dropdown-item ref="companyRef" title="酒管公司">
            <ul class="company-wrap">
              <li
                v-for="item in companys"
                :key="item"
                @click="toHotelCompany(item)"
              >
                {{ item.companyName }}
              </li>
            </ul>
          </van-dropdown-item>
        </van-dropdown-menu>
        <div class="title" @click="toBrandNew">品牌资讯</div>
        <div class="title" @click="toAboutUs">关于我们</div>
        <div class="title" @click="toJoinUs">加入我们</div>
        <div class="title" @click="englishJump">English</div>
      </div>
      <div
        v-if="$route.path == '/foreignPage'"
        class="tabs-warp"
        style="width: 500rem; height: 100rem"
      >
        <div
          v-for="(item, index) in englishData"
          :key="index"
          class="title"
          @click="toEnglish(item)"
        >
          {{ item.name }}
        </div>
        <div class="title chinaVer" style="margin-left: auto" @click="toHome()">
          中文
        </div>
      </div>
    </div>

    <!-- 品牌矩阵弹窗 -->
    <van-popup
      v-model:show="showBrandMatrix"
      round
      position="bottom"
      :style="{ width: '100%', height: '63%' ,}"
    >
      <div class="matrix-popup">
        <div class="matrix-header">
          <van-icon name="cross" @click="showBrandMatrix = false" />
        </div>
        <div class="matrix-content">
          <div class="matrix-scroll-wrapper">
            <div class="matrix-table">
              <div
                v-for="(item, index) in brandColumns"
                :key="item.label"
                class="matrix-row data-row"
                :class="{ 'even-row': index % 2 === 0 }"
              >
                <!-- 等级标签 -->
                <div class="matrix-cell grade-cell">
                  {{ item.label }}
                </div>
                <div
                  class="matrix-cell brand-cell"
                >
                  <div class="brand-logos">
                    <img
                      v-for="brand in item.brands.filter(
                        (b) => b.logo
                      )"
                      :key="brand.id"
                      :src="brand.logo"
                      :alt="brand.name"
                      @click="goBrandDetail(brand.id)"
                      class="brand-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="matrix-footer-note">
            ※以上仅为艺龙酒店科技平台的部分品牌
          </div>
        </div>
      </div>
    </van-popup>
  </van-sticky>
</template>

<script setup>
import { getAssignPlat, getCompany, getBrandArchiveSpecialByApp } from "@/api/index";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { CHANNEL, RECOMMEND_Id } from "@/utils/constants";
import { getSessionStorage } from "@/utils/storage";
import { useEnglishDataStore } from "@/store/englishData";
import { storeToRefs } from "pinia";
import { trackEvent } from "@/utils/tracklog.js";

const store = useEnglishDataStore();
const { englishData } = storeToRefs(store);
const brandColumns = ref([]);
const companys = ref([]);
const assignPlats = ref([]);
const companyRef = ref(null);
const assignPlatRef = ref(null);
const showBrandMatrix = ref(false);
onMounted(() => {
  Promise.all([
    getBrandArchiveSpecialByApp().then((res)=>{
    console.log("🐙 res", res);
    brandColumns.value = res;
    }),
    getCompany().then((data) => {
      console.log("🌈 data", data);

      companys.value = data;
    }),
    getAssignPlat().then((data) => {
      console.log("🫒 data", data);

      assignPlats.value = data.filter((item) => item.id !== 1);
    }),
  ]);
});
const router = useRouter();
const toHomePage = () => {
  router.push("/index");
};
const toHotelCompany = ({ id, companyName }) => {
  //埋点 酒馆公司
  trackEvent(
    `顶栏-酒管公司-${companyName}选项`,
    "点击",
    `顶栏-酒管公司-${companyName}选项`,
    { path: `/hotel/${id}` },
    0,
    new Date().getTime()
  );
  router.push(`/hotel/${id}`);
  companyRef.value.toggle();
};
const toAssignPlat = ({ id, enableCompanyName }) => {
  //埋点 业务中台
  trackEvent(
    `顶栏-业务中台-${enableCompanyName}选项`,
    "点击",
    `顶栏-业务中台-${enableCompanyName}选项`,
    { path: `/assignPlatform/${id}` },
    0,
    new Date().getTime()
  );
  router.push(`/assignPlatform/${id}`);
  assignPlatRef.value.toggle();
};
const toBrandNew = () => {
  router.push("/brandNews");
};
const toAboutUs = () => {
  router.push("/aboutUs");
};
const toJoinUs = () => {
  router.push({
    // path: "/joinUs",
    path: "/joinUs/index",
    query: {
      channel: getSessionStorage(CHANNEL) || "official",
      recommendId: getSessionStorage(RECOMMEND_Id) || "",
    },
  });
};

const englishJump = () => {
  router.push({
    path: "/foreignPage",
  });
};

const toEnglish = (item) => {
  router.push({
    path: "/foreignPage",
    query: {
      id: item.id,
    },
  });
};

const toHome = () => {
  router.push("/index");
};

const goBrandDetail = (id) => {
  showBrandMatrix.value = false;
  // 这里根据你的实际路由调整
  router.push(`/brandColumn/${id}`);
};


</script>

<style lang="scss" scoped>
.header-wrap {
  display: flex;
  align-items: center;
  padding: 20rem 15rem 0;
  background: $color-text-d;
  img {
    width: 80rem;
    height: 80rem;
  }
  .tabs-warp {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    -webkit-scrollbar {
      display: none !important;
    }
    ::v-deep .van-dropdown-menu__bar {
      box-shadow: none;
      background: none;
    }
    ::v-deep .van-ellipsis {
      font-size: 26rem;
      color: #fff;
    }
    ::v-deep .van-dropdown-menu {
      margin-right: 20rem;
    }
    .title {
      font-size: 26rem;
      padding: 0 20rem;
      white-space: nowrap;
      color: #fff;
    }
  }
  .company-wrap {
    display: flex;
    flex-wrap: wrap;
    background: $color-text-d;
    padding: 20rem 0;
    li {
      width: 25%;
      text-align: center;
      color: #fff;
      font-size: 24rem;
      line-height: 50rem;
    }
  }
}

.chinaVer {
  position: absolute;
  right: 10px;
}

// 品牌矩阵弹窗样式
.matrix-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;

  .matrix-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20rem 25rem;
    .van-icon {
      font-size: 40rem;
      cursor: pointer;
    }
  }

  .matrix-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .matrix-scroll-wrapper {
      flex: 1;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }

    .matrix-table {
      min-width: 100%;
      display: table;
      border-collapse: collapse;

      .matrix-row {
        display: table-row;

        &.data-row {
          &.even-row {
            background: #f9f9f9;
            
            .grade-cell {
              background: #f9f9f9;
            }
          }
          
          &:not(.even-row) .grade-cell {
            background: #fff;
          }
        }
      }
      
      .matrix-cell {
        display: table-cell;
        padding: 20rem;
        vertical-align: middle;
        text-align: center;
        min-width: 300rem;
        &.grade-cell {
          position: sticky;
          color: #005352;
          left: 0;
          font-weight: bold;
          font-size: 28rem;
          min-width: 120rem;
          z-index: 2;
        }

        &.brand-cell {
          .brand-logos {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            gap: 30rem;
            min-height: 100rem;

            .brand-logo {
              width: 100rem;
              height: 100rem;
              object-fit: cover;
              border-radius: 10rem;
              cursor: pointer;
              transition: transform 0.2s;

              &:hover {
                transform: scale(1.1);
              }
            }
          }
        }
      }
    }

    .matrix-footer-note {
      padding: 30rem 15rem 50rem 15rem;
      text-align: center;
      font-size: 24rem;
      color: #999;
      background: #fff;
      border-top: 2rem solid #f0f0f0;
    }
  }
}
</style>
